// extracted by mini-css-extract-plugin
module.exports = {"container":"_1MGVMHYuV2u5Mnd4iJrB5z","container_v2":"_3FD032u_YFLQKVcG3ziO6E"};